import { useAuth0 } from "@auth0/auth0-react";
import { LockReset } from "@mui/icons-material";
import { Button } from "@mui/material";
import Nav from "components/Nav/Nav";
import styled from "styled-components/macro";

export function AuthenticationFailedPage() {
  const { loginWithRedirect } = useAuth0();

  return (
    <>
      <Nav />
      <Styles>
        <h1>Authentication Failed</h1>
        <p>Please try logging in again:</p>
        <Button
          variant="contained"
          disableElevation={true}
          onClick={() =>
            loginWithRedirect({
              appState: {
                targetUrl: "/",
              },
            })
          }
          endIcon={<LockReset />}
        >
          Sign In
        </Button>
      </Styles>
    </>
  );
}
const Styles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap: 1em;
  min-height: 100vh;
  h1 {
    font-size: 1.5em;
  }
  button {
    color: white;
    margin-top: 1em;
    text-transform: none;
    background: rgb(48, 105, 146);
    font-family: "Roboto";
    font-size: 16px;
  }
`;
